import React from "react";
import { SimpleHeader } from "./SimpleHeader";

interface HotelHeaderProps {
  company: server.dto.Company
}

export const HotelHeader = ({ company }: HotelHeaderProps) =>
  <SimpleHeader title={company.name} isDeleted={company.isDeleted}>
    {company.address.formatted.length > 0 && <div className="purple-header-text">{company.address.formatted.join(", ")}</div>}
  </SimpleHeader>;
